export default __webpack_public_path__ + "static/media/ace-logo.b67c2c62.png";